import React from 'react';
import { motion } from 'framer-motion';
import { ArrowRight } from 'lucide-react';
import { Link } from 'react-router-dom';
import { articles } from '../data/articles';
export function FieldNotes() {
  return <section id="field-notes" className="relative py-24 bg-white" data-id="element-45">
      {/* Subtle basalt texture */}
      <div className="absolute inset-0 texture-basalt opacity-40" data-id="element-46" />

      <div className="relative max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-47">
        <div className="text-center mb-16" data-id="element-48">
          <span className="text-[#A07656] uppercase tracking-widest text-sm font-semibold mb-2 block" data-id="element-49">
            Insights
          </span>
          <h2 className="text-4xl md:text-5xl font-serif font-bold text-[#1A1A1A]" data-id="element-50">
            Field Notes
          </h2>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8" data-id="element-51">
          {articles.map((article, index) => <motion.article key={article.slug} initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.5,
          delay: index * 0.1
        }} data-id="element-52">
              <Link to={`/articles/${article.slug}`} className="group block" data-id="element-53">
                <div className="relative overflow-hidden aspect-[4/3] mb-6 bg-[#E8E4DF]" data-id="element-54">
                  <img src={article.image} alt={article.title} className="w-full h-full object-cover transition-transform duration-700 group-hover:scale-105" data-id="element-55" />
                  <div className="absolute inset-0 bg-[#1A1A1A]/0 group-hover:bg-[#1A1A1A]/20 transition-colors duration-500" data-id="element-56" />
                </div>
                <div className="space-y-3" data-id="element-57">
                  <span className="text-xs font-bold uppercase tracking-widest text-[#A07656]" data-id="element-58">
                    {article.category}
                  </span>
                  <h3 className="text-xl font-serif font-bold text-[#1A1A1A] group-hover:text-[#A07656] transition-colors" data-id="element-59">
                    {article.title}
                  </h3>
                  <p className="text-[#595959] text-sm leading-relaxed" data-id="element-60">
                    {article.excerpt}
                  </p>
                  <div className="pt-2 flex items-center gap-2 text-sm font-semibold text-[#1A1A1A] group-hover:gap-3 transition-all" data-id="element-61">
                    Read Article <ArrowRight className="w-4 h-4" data-id="element-62" />
                  </div>
                </div>
              </Link>
            </motion.article>)}
        </div>
      </div>
    </section>;
}